import styled from 'styled-components';

export const StyledActionWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 1.6rem;
  justify-content: center;

  p {
    color: ${({ theme }) => theme.colors.text.main};
  }

  button {
    min-width: 17rem;
  }
`;
